import { jsx as o, jsxs as x, Fragment as P } from "react/jsx-runtime";
import { withManagedProps as y } from "@made-people/managed-props";
import { z as e } from "zod";
import { withZod as S } from "@made-people/react-prop-guard";
import { Drawer as O } from "@made-people/blueprint-drawer";
import { useState as v, useCallback as B, Suspense as Q, useEffect as U, startTransition as R, useMemo as A } from "react";
import { useCountriesAndLanguages as _ } from "@made-people/grease-countries-and-languages";
import { selectBoxSchema as W, SelectBox as M, SelectBoxItem as V } from "@made-people/blueprint-form";
import { Flag as X } from "@made-people/blueprint-flags";
import { useClientOnly as Y } from "@made-people/ui-hooks";
import { currencyDisplayBlueprint as ee, siteSettingsFormBlueprint as z, siteSettingsDrawerBlueprint as te, siteSettingsTriggerBlueprint as ne } from "./index-blueprint.es.js";
import { useTranslate as Z } from "@made-people/grease-translations";
import { buttonAsButtonSchema as H, ButtonAsButton as F } from "@made-people/blueprint-button";
import { overlayEventEmitter as E } from "@made-people/blueprint-overlay";
import { useSites as oe } from "@made-people/grease-sites";
import ae from "clsx";
import "@made-people/blueprint";
const $ = W.omit({ children: !0 }).extend({
  initialCountry: e.custom().optional(),
  onChange: e.function().args(e.custom()).returns(e.void()).optional(),
  displayFlag: e.boolean().optional()
}), j = y(
  "CountrySelector",
  S(
    {
      schema: $,
      defaultProps: {
        label: "Country_Selector_Label",
        displayFlag: !0,
        onChange: () => {
        }
      }
    },
    (t) => {
      const n = Y(), { countries: a, currentCountryCode: i } = _(), [u, s] = v(
        t.initialCountry ?? i
      ), { onChange: r, ...d } = t, g = B(
        (c) => {
          s(c), r == null || r(c);
        },
        [r]
      );
      if (!n)
        return null;
      const l = a.find(
        (c) => c.countryCode === u
      );
      if (l)
        return /* @__PURE__ */ o(Q, { fallback: null, children: /* @__PURE__ */ o(
          M,
          {
            value: l.countryCode,
            ...d,
            onChange: g,
            children: a.map((c) => /* @__PURE__ */ o(
              V,
              {
                value: c.countryCode,
                label: c.name,
                icon: t.displayFlag ? /* @__PURE__ */ o(X, { code: c.countryCode }) : void 0
              },
              c.countryCode
            ))
          }
        ) });
    }
  )
), re = W.omit({ children: !0 }).extend({
  selectedLanguageCode: e.string().optional(),
  onChange: e.function().args(e.string()).returns(e.void()).optional(),
  isEnabled: e.boolean().optional()
}), q = y(
  "LanguageSelector",
  S(
    {
      schema: re,
      defaultProps: {
        label: "Language_Selector_Label",
        isEnabled: !0,
        onChange: () => {
        }
      }
    },
    ({ ...t }) => {
      const { languages: n, currentLanguageCode: a } = _(), [i, u] = v(a), s = t.selectedLanguageCode !== void 0, r = s ? t.selectedLanguageCode : i;
      if (U(() => {
        s || R(() => {
          u(a);
        });
      }, [a, s]), !t.isEnabled)
        return null;
      const { onChange: d, ...g } = t;
      return /* @__PURE__ */ o(
        M,
        {
          value: r,
          ...g,
          onChange: (l) => {
            s || u(l), d == null || d(l);
          },
          children: n.map((l) => /* @__PURE__ */ o(
            V,
            {
              value: l.languageCode,
              label: l.name
            },
            l.languageCode
          ))
        }
      );
    }
  )
), ie = e.object({
  variants: e.custom().optional(),
  currencyCode: e.string().optional()
}), G = y(
  "CurrencyDisplay",
  S(ie, ({ variants: t, currencyCode: n }) => {
    const a = Z(), i = ee.styles(t);
    return n ? /* @__PURE__ */ x("div", { className: i.wrapper, children: [
      /* @__PURE__ */ o("span", { className: i.label, children: a("Site_Settings_CurrencyDisplay_Label") }),
      /* @__PURE__ */ o("span", { className: i.currency, children: n })
    ] }) : null;
  })
), I = e.object({
  variants: e.custom().optional(),
  buttons: e.object({
    apply: H.optional(),
    close: H.optional()
  }).optional(),
  languageSelector: e.object({
    isEnabled: e.boolean().optional()
  }).optional(),
  // This is the method we call regardless of the form type, when the user has clicked
  // the apply button. It's separately defined from the button onClick function as
  // it has a clear purpose and consumers might want to do custom things with the button.
  onApply: e.function().args(e.custom(), e.string(), e.string()).returns(e.void().or(e.promise(e.void()))).optional()
}), se = y(
  "SiteSettingsCountryLanguageForm",
  S(I, ({ variants: t, buttons: n }) => {
    const a = z.styles(t), {
      currentCountryCode: i,
      currentLanguageCode: u,
      updateCountryAndLanguage: s,
      countries: r
    } = _(), [d, g] = v(i), [l, c] = v(u), b = B(() => {
      s(
        d,
        l,
        window.location.pathname
      ), E.emit("close", {
        overlayId: "site-settings"
      });
    }, [d, l]), k = B((w) => {
      g(w);
      const f = r.find(
        (h) => h.countryCode === w
      );
      c((f == null ? void 0 : f.languageCode) ?? l);
    }, []);
    return /* @__PURE__ */ o(P, { children: /* @__PURE__ */ x("div", { className: a.formWrapper, children: [
      /* @__PURE__ */ o(j, { onChange: k }),
      /* @__PURE__ */ o(
        q,
        {
          onChange: c,
          selectedLanguageCode: l
        }
      ),
      /* @__PURE__ */ o(G, {}),
      /* @__PURE__ */ o(
        F,
        {
          label: "Site_Settings_Apply_Button_Label",
          onClick: b,
          variants: {
            width: "full"
          }
        }
      ),
      /* @__PURE__ */ o(
        F,
        {
          variants: {
            width: "full"
          },
          onClick: () => {
            E.emit("close", {
              overlayId: "site-settings"
            });
          },
          label: "Site_Settings_Close_Button_Label",
          ...n == null ? void 0 : n.close
        }
      )
    ] }) });
  })
), le = y(
  "SiteSettingsSitesForm",
  S(
    I,
    ({ variants: t, buttons: n, languageSelector: a, onApply: i }) => {
      const u = z.styles(t), s = (a == null ? void 0 : a.isEnabled) ?? !0, {
        languages: r,
        countries: d,
        currentCountryCode: g,
        currentLanguageCode: l
      } = _(), c = oe(), [b, k] = v(g), [w, f] = v(l);
      U(() => {
        k(g), s && f(l);
      }, [g, l, s]);
      const h = A(() => {
        const m = c.find(
          (C) => C.countryCodes.includes(b)
        );
        return m || console.error(`No site found for countryCode "${b}"`), m;
      }, [c, b]), D = A(() => h ? r.filter(
        (m) => h.siteSlugs.some(
          (C) => C.languageCode === m.languageCode
        )
      ) : [], [r, h]), J = B(
        (m) => {
          var N;
          k(m);
          const C = c.find(
            (L) => L.countryCodes.includes(m)
          );
          if (!C)
            return;
          const p = d.find(
            (L) => L.countryCode === m
          );
          if (p != null && p.languageCode)
            f(p.languageCode);
          else {
            const L = (N = r.find(
              (K) => {
                var T;
                return K.languageCode === ((T = C.siteSlugs[0]) == null ? void 0 : T.languageCode);
              }
            )) == null ? void 0 : N.languageCode;
            L && f(L);
          }
        },
        [c, d, r]
      );
      return !(D != null && D.length) || !h ? null : /* @__PURE__ */ x("div", { className: u.formWrapper, children: [
        /* @__PURE__ */ o(j, { onChange: J }),
        s && /* @__PURE__ */ o(
          q,
          {
            onChange: f,
            selectedLanguageCode: w
          }
        ),
        /* @__PURE__ */ o(G, { currencyCode: h.currencyCode }),
        /* @__PURE__ */ o(
          F,
          {
            label: "Site_Settings_Apply_Button_Label",
            variants: {
              width: "full"
            },
            ...n == null ? void 0 : n.apply,
            onClick: (m) => {
              var C, p;
              (p = (C = n == null ? void 0 : n.apply) == null ? void 0 : C.onClick) == null || p.call(C, m), h && (i == null || i(h, b, w));
            }
          }
        ),
        /* @__PURE__ */ o(
          F,
          {
            variants: {
              width: "full"
            },
            onClick: () => {
              E.emit("close", {
                overlayId: "site-settings"
              });
            },
            label: "Site_Settings_Close_Button_Label",
            ...n == null ? void 0 : n.close
          }
        )
      ] });
    }
  )
), ce = e.object({
  as: e.literal("drawer").optional(),
  mode: e.enum(["country-language", "sites"]).optional(),
  drawer: e.custom().optional(),
  form: I.optional()
}), De = y(
  "SiteSettings",
  S(ce, (t) => {
    const { mode: n } = t;
    let a = se;
    return n === "sites" && (a = le), /* @__PURE__ */ x(P, { children: [
      t.as === "drawer" && /* @__PURE__ */ o(
        O,
        {
          customOverlayId: "site-settings",
          hasOverlay: !0,
          hasScaledBackground: !0,
          setBackgroundColorOnScale: !1,
          hasHandle: !1,
          variants: {
            dragHandle: "false",
            rounded: "none",
            background: "white",
            direction: "right"
          },
          direction: "right",
          ...t.drawer,
          children: /* @__PURE__ */ o(O.Content, { children: /* @__PURE__ */ o(a, { ...t.form }) })
        }
      ),
      t.as !== "drawer" && /* @__PURE__ */ o(a, { ...t.form })
    ] });
  })
), ue = $, je = y(
  "CountrySelectorUpdateOnChange",
  S(
    {
      schema: ue,
      defaultProps: { label: "Country_Selector_Label", onChange: () => {
      } }
    },
    (t) => {
      const { countries: n, currentCountryCode: a, updateCountryAndLanguage: i } = _(), u = B(
        (s) => {
          const r = n.find(
            (d) => d.countryCode === s
          );
          !r || r.countryCode === a || i(
            r.countryCode,
            r.languageCode,
            // Update language to default language of the country
            window.location.pathname
          );
        },
        [n, a, i]
      );
      return /* @__PURE__ */ o(j, { ...t, onChange: u });
    }
  )
), de = e.object({
  drawer: e.custom().optional(),
  children: e.custom().optional()
}), Ie = y(
  "SiteSettingsDrawer",
  S(de, (t) => (te.styles(), /* @__PURE__ */ o(
    O,
    {
      customOverlayId: "site-settings",
      hasOverlay: !0,
      hasScaledBackground: !0,
      setBackgroundColorOnScale: !1,
      hasHandle: !1,
      variants: {
        dragHandle: "false",
        rounded: "none",
        background: "white",
        direction: "right"
      },
      direction: "right",
      ...t.drawer,
      children: /* @__PURE__ */ o(O.Content, { children: t.children })
    }
  )))
), ge = () => {
  const { currentCountryCode: t, countries: n, languages: a, currentLanguageCode: i } = _(), u = Z(), s = n.find(
    (g) => g.countryCode === t
  ), r = a.find(
    (g) => g.languageCode === i
  );
  return u("Site_Settings_Trigger_Label", {
    country: (s == null ? void 0 : s.name) ?? "",
    countryCode: t,
    languageCode: i,
    language: (r == null ? void 0 : r.name) ?? ""
  });
}, Ce = e.object({
  isEnabled: e.boolean().optional(),
  display: e.array(e.enum(["country", "language", "languageCode", "countryCode"])).optional(),
  divider: e.string().optional(),
  className: e.string().optional(),
  variants: e.custom().optional()
}), Ne = y(
  "SiteSettingsTrigger",
  S(
    {
      schema: Ce,
      defaultProps: {
        isEnabled: !0
      }
    },
    ({ variants: t, className: n, isEnabled: a }) => {
      const i = ne.styles(t), u = ge();
      return a ? /* @__PURE__ */ o(
        "button",
        {
          className: ae(i.base, n),
          tabIndex: 0,
          onClick: () => {
            E.emit("open", {
              overlayId: "site-settings"
            });
          },
          type: "button",
          "aria-label": "Open site settings",
          children: u
        }
      ) : null;
    }
  )
);
export {
  j as CountrySelector,
  je as CountrySelectorUpdateOnChange,
  G as CurrencyDisplay,
  q as LanguageSelector,
  De as SiteSettings,
  se as SiteSettingsCountryLanguageForm,
  Ie as SiteSettingsDrawer,
  le as SiteSettingsSitesForm,
  Ne as SiteSettingsTrigger,
  $ as countrySelectorSchema,
  ue as countrySelectorUpdateOnChangeSchema,
  ie as currencyDisplaySchema,
  re as languageSelectorSchema,
  de as siteSettingsDrawerSchema,
  I as siteSettingsFormSchema,
  ce as siteSettingsSchema,
  Ce as siteSettingsTriggerSchema,
  ge as useSiteSettingsTriggerLabel
};
//# sourceMappingURL=index.es.js.map
